import { motion } from 'framer-motion';
import styled from 'styled-components';
import { margin } from 'styled-system';
import { MarginProps } from '../../../../theme/styledProps';
import { BREAKPOINTS } from '../../../BeFi20.meta';
import { Wrapper as WrapperBase } from '../../../BeFi20.styles';

export const Wrapper = styled(WrapperBase)({
  gap: 32,
  paddingTop: 32,
  paddingBottom: 0,
  justifyContent: 'flex-start',

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    padding: 32,
  },

  [`@media (min-height: 480px)`]: {
    justifyContent: 'center',
    gap: 56,
  },
});

export const Main = styled(motion.section)<MarginProps>(
  ({ theme }) => ({
    boxSizing: 'border-box',
    display: 'grid',
    placeContent: 'center',
    padding: 24,

    [`@media (min-width: ${BREAKPOINTS.sm})`]: {
      borderRadius: 12,
      boxShadow: theme.shadows['500'],
      maxWidth: 640,
      width: '100%',
      height: 'min(80vh, 400px)',
      background: theme.colors.bg,
    },
  }),
  margin,
);
